import { render, staticRenderFns } from "./localInvestAnalysis.vue?vue&type=template&id=c6766462&"
import script from "./localInvestAnalysis.vue?vue&type=script&lang=js&"
export * from "./localInvestAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./localInvestAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports